import { renderSearch } from "../js/components/SearchModules/Search/renderSearch.jsx";
import globalHeader from "../js/components/GlobalHeader/globalHeader.js";
import "../js/components/Carousel/Carousel.jsx";

// This is required to make Storybook run JS when patterns are choosen
document.addEventListener("DOMContentLoaded", () => {
  renderSearch();
  globalHeader();
});
